const types = {
  SET_JWT: 'SET_JWT',
  SET_EMAIL: 'SET_EMAIL',
};

export default types;
